import { Injectable } from "@angular/core";
import { IEpubAnnotations } from "./base-epub-annotation.service";
import { DocumentManagerService } from "../document/document-manager.service";
import { AsgardDocEpub } from "src/app/core/documents/asgard-doc-epub";

@Injectable({ providedIn: 'root' })
export class EpubAnnotationsSerializerService {
    constructor(
        private readonly documentManagerService: DocumentManagerService
    ) { }

    public async serialize(): Promise<IEpubAnnotations| undefined> {
        const doc = this.documentManagerService.currentDoc as AsgardDocEpub;
        const bookId = doc.epubViewerInstance?.readerPublication.getSourcePublication().getMetadata().getUniqueIdentifier()?.content.value;
        if (!(this.documentManagerService.currentDoc instanceof AsgardDocEpub) || !bookId) return undefined;

        return { bookId: bookId!, annotations: await doc.getAnnotations() };
    }

    public deserialize(payload: IEpubAnnotations) {
        if (!payload.bookId) {
            throw new Error('no bookId in payload');
        }
        const doc = this.documentManagerService.currentDoc as AsgardDocEpub;
        doc.applyAnnotations(payload.annotations);
    }
}